import { FC } from 'react';

import { IconColor, iconColors } from 'app/components/v3/components/Icon/helpers';

import { iconSizes } from './helpers';
import { svgPaths24 } from './svg-data';
import { svgPaths16 } from './svg-data-16';
import { IconName } from './types';
import { getSemanticColorVariable } from '../../theme/colors';

// Local Typings
export type IconSize = 'lg' | 'md' | 'sm' | 'xl' | 'xs' | 'xxl' | 'xxs' | 'xxxs';

export interface IconProps {
  color?: 'inherit' | IconColor;
  name: IconName;
  size?: IconSize | number;
}

// Local Variables
const viewBox24 = '0 0 24 24';
const viewBox16 = '0 0 16 16';

// Component Definition
const Icon: FC<IconProps> = ({
  color,
  name,
  size = 'xs',
}) => {
  const fillColor = color === 'inherit'
    ? 'currentColor'
    : getSemanticColorVariable(iconColors[color ?? 'default']);
  const svgSize = typeof size === 'number' ? size : iconSizes[size];

  // all the icon names prefixed with "old-" do not have 16x16 versions
  const isOldName = (name as string).startsWith('old-');

  const isSmallSize = (size === 'xxs' || size === 'xxxs')
    && !isOldName;

  const style = {
    // TODO: the passed color is not always respected in IconButton
    ['--icon-color' as string]: color
      ? fillColor
      : `var(--button-content-color, ${fillColor})`,
  };

  return (
    <svg
      className="icon"
      height={svgSize}
      style={style}
      viewBox={isSmallSize ? viewBox16 : viewBox24}
      width={svgSize}
      xmlns="http://www.w3.org/2000/svg"
    >
      {isSmallSize ? svgPaths16[name] : svgPaths24[name]}
    </svg>
  );
};

export default Icon;
